export const LeaveAccrualFrequency = {
  MONTHLY: "monthly",
  YEARLY: "yearly"
} as const;

export const LeaveAccrualMethod = {
  LUMP_SUM: "lump_sum",
  ACCRUAL: "accrual"
} as const;

export const LeaveApplicationStatus = {
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected"
} as const;
